import { isWellShaped } from 'Global/Helpers/objectHelpers'

export const location = state => {
  if (isWellShaped(state, 'routing.locationBeforeTransitions.pathname')) {
    return state.routing.locationBeforeTransitions.pathname
  }

  return ''
}
